import { Match } from './match.model';
import { Team } from './team.model';
import { WinnerOf } from './winner-of.model';

export class MatchCollection {
  private _data: Array<Match>;

  constructor(items: Array<Match> = []) {
    this._data = [...items];
  }

  findMatchWithSeed(seed: number) {
    const found = this._data.find((match) => {
      const slot1seed = (match.slot1 as Team).seed;
      const slot2seed = (match.slot2 as Team).seed;
      return slot1seed === seed || slot2seed === seed;
    });
    return found;
  }

  findById(id: number) {
    return this._data.find((m) => m.id === id);
  }

  findByWinnerSlot(match: Match) {
    return this._data.find((m) => {
      const slot1Match = (m.slot1 as WinnerOf).matchId;
      const slot2Match = (m.slot2 as WinnerOf).matchId;

      return slot1Match === match.id || slot2Match === match.id;
    });
  }

  push(match: Match) {
    this._data.push(match);
  }

  toArray() {
    return this._data;
  }
}
